class FormFeedback {
  constructor(element) {
    this.form = element;
    this.submitButton = this.form.querySelector('.form-content__submit');
    this.popup = document.querySelector('.form-feedback-popup');
    this.popupCloseBtn = this.popup?.querySelector('.form-feedback-popup__close');
    this.popupOkBtn = this.popup?.querySelector('.form-feedback-popup__btn');
    this.fileInput = this.form.querySelector('input[type="file"]');
    this.maxFileSize = 10 * 1024 * 1024; // 10 MB
    this.labels = this.form.querySelectorAll('.form-content__label');
    this.contentWrapper = this.form.closest('.form-feedback__content');
    this.thankYouBlock = this.contentWrapper?.querySelector('.form-feedback__thank-you');

    this.init();
  }

  init() {
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));

    if (this.fileInput) {
      this.fileInput.addEventListener('change', (e) => this.handleFileChange(e));
    }

    if (this.popupCloseBtn) {
      this.popupCloseBtn.addEventListener('click', () => this.closePopup());
    }

    if (this.popupOkBtn) {
      this.popupOkBtn.addEventListener('click', () => this.closePopup());
    }
  }

  handleFileChange(e) {
    const file = e.target.files[0];
    const errorElement = this.form.querySelector('.input-file-wrap .form-content__error');

    if (file && file.size > this.maxFileSize) {
      if (errorElement) {
        errorElement.style.display = 'block';
      }
      e.target.value = '';
    } else {
      if (errorElement) {
        errorElement.style.display = 'none';
      }
    }
  }

  validateForm() {
    let isValid = true;
    const requiredFields = this.form.querySelectorAll('.required');

    requiredFields.forEach((field) => {
      const label = field.closest('.form-content__label');
      const errorElement = label?.querySelector('.form-content__error');

      if (!field.value.trim()) {
        isValid = false;
        if (errorElement) {
          errorElement.style.display = 'block';
        }
        field.classList.add('error');
        if (label) {
          label.classList.remove('valid');
          label.classList.add('invalid');
        }
      } else {
        if (errorElement) {
          errorElement.style.display = 'none';
        }
        field.classList.remove('error');
        if (label) {
          label.classList.remove('invalid');
          label.classList.add('valid');
        }
      }

      // Валидация email
      if (field.type === 'email' && field.value.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(field.value.trim())) {
          isValid = false;
          if (errorElement) {
            errorElement.style.display = 'block';
            errorElement.textContent = 'Invalid email format';
          }
          field.classList.add('error');
          if (label) {
            label.classList.remove('valid');
            label.classList.add('invalid');
          }
        }
      }
    });

    // Проверка размера файла
    if (this.fileInput && this.fileInput.files[0]) {
      if (this.fileInput.files[0].size > this.maxFileSize) {
        isValid = false;
        const errorElement = this.form.querySelector('.input-file-wrap .form-content__error');
        if (errorElement) {
          errorElement.style.display = 'block';
        }
      }
    }

    return isValid;
  }

  clearValidationClasses() {
    this.labels.forEach((label) => {
      label.classList.remove('valid', 'invalid');
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    const formData = new FormData(this.form);
    formData.append('action', 'submit_form_feedback');
    formData.append('nonce', backendData?.nonce || '');

    // Добавляем email настройки из data-атрибутов
    if (this.form.dataset.emailTo) {
      formData.append('email_to', this.form.dataset.emailTo);
    }
    if (this.form.dataset.emailFrom) {
      formData.append('email_from', this.form.dataset.emailFrom);
    }
    if (this.form.dataset.emailSubject) {
      formData.append('email_subject', this.form.dataset.emailSubject);
    }

    // Отключаем кнопку отправки
    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.textContent = 'Sending...';
    }

    try {
      const response = await fetch(backendData.ajaxUrl, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        this.showSuccess();
        this.form.reset();
        this.clearValidationClasses();
        this.replaceFormWithThankYou();
      } else {
        this.showError(data.data?.message || 'An error occurred. Please try again.');
      }
    } catch (error) {
      this.showError('Network error. Please try again.');
    } finally {
      // Включаем кнопку отправки обратно
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.innerHTML = 'Send <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.97625 22.9528L23.9503 3.97878M23.9503 3.97878L11.4332 4.12149M23.9503 3.97878L23.8076 16.4959" stroke="black" stroke-width="1.16667"/></svg>';
      }
    }
  }

  showSuccess() {
    if (this.popup) {
      this.popup.classList.add('active');
    }
  }

  replaceFormWithThankYou() {
    if (this.form && this.thankYouBlock) {
      this.form.style.display = 'none';
      this.thankYouBlock.style.display = 'block';
    }
  }

  showError(message) {
    // Можно добавить отображение ошибки, если нужно
    alert(message);
  }

  closePopup() {
    if (this.popup) {
      this.popup.classList.remove('active');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const formElement = document.querySelector('#form-feedback');
  if (formElement) {
    new FormFeedback(formElement);
  }
});

